import CryptoJS from "crypto-js";

var encryptionKey = process.env.VUE_APP_ENCRYPTKEY;
// Function to encrypt data
export function encryptData(data, key) {
  return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
}

// Function to decrypt data
export function decryptData(encryptedData, key) {
  if (key) {
    try {
      const bytes = CryptoJS.AES.decrypt(encryptedData, key);
      const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
      return JSON.parse(decryptedData);
    } catch (error) {
      console.error("Decryption failed or invalid JSON format:", error);
      return null;
    }
  } else {
    return null;
  }
}

// Override sessionStorage.setItem to automatically encrypt data
export function overrideSetItem() {
  const originalSetItem = sessionStorage.setItem;
  sessionStorage.setItem = function (key, value) {
    const encryptedValue = encryptData(value, encryptionKey);
    originalSetItem.call(sessionStorage, key, encryptedValue);
  };
}

// Override sessionStorage.getItem to automatically decrypt data
export function overrideGetItem() {
  const originalGetItem = sessionStorage.getItem;
  sessionStorage.getItem = function (key) {
    const encryptedValue = originalGetItem.call(sessionStorage, key);
    if (encryptedValue) {
      return decryptData(encryptedValue, encryptionKey);
    }
    return null;
  };
}

// Override sessionStorage.clear to work without errors
export function overrideClear() {
  const originalClear = sessionStorage.clear;
  sessionStorage.clear = function () {
    originalClear.call(sessionStorage);
  };
}